import { HugeiconsIcon } from '@hugeicons/react';
import {
  AddTeam02Icon,
  AiBrain01Icon, ArrowLeft01FreeIcons, ArrowRight01FreeIcons,
  BirthdayCakeIcon,
  Clock02Icon,
  Edit01Icon, Hold01Icon,
  PlusSignIcon
} from '@hugeicons/core-free-icons';
import * as React from 'react';
import RadioCards from '../Inputs/RadioCards';
import { Button, Form } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { ReactNode, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CustomersFilter, CustomersGroupType } from '@next-is-free-monorepo/next-is-free-types';
import { apiV1 } from '../../utils/apiClient';
import { useNavigate } from '@tanstack/react-router';

interface CustomersGroupTemplatesModalProps {
}

const presets: {
  value: string,
  name: string | undefined,
  rules: CustomersFilter[],
  label: string,
  description: string,
  icon: ReactNode
}[] = [
  {
    value: 'custom',
    name: undefined,
    rules: [],
    label: 'Personalizzato',
    description: 'Scegli regole personalizzate',
    icon: <HugeiconsIcon icon={PlusSignIcon} />
  },
  {
    label: 'Nuovi clienti',
    description: 'Clienti che hanno aggiunto il tuo negozio da meno di una settimana.',
    icon: <HugeiconsIcon icon={AddTeam02Icon} />,
    value: 'new_customers',
    name: 'Nuovi clienti',
    rules: [
      {
        property: 'added_days_ago',
        operator: 'less_than',
        operator_type: 'number',
        value: 7
      }
    ]
  }, {
    label: 'Visite recenti',
    description: 'Clienti che hanno visitato il negozio nell\'ultima settimana',
    icon: <HugeiconsIcon icon={Clock02Icon} />,
    value: 'recent_visits',
    name: 'Visite recenti',
    rules: [
      {
        property: 'latest_visit_days_ago',
        operator_type: 'number',
        operator: 'less_than',
        value: 7
      }
    ]
  }, {
    label: 'Giovani',
    description: 'Clienti con meno di 30 anni.',
    icon: <HugeiconsIcon icon={BirthdayCakeIcon} />,
    value: 'young_customers',
    name: 'Clienti Giovani',
    rules: [
      {
        property: 'age',
        operator_type: 'number',
        operator: 'less_than',
        value: 30
      }
    ]
  }];

const CustomersGroupSelectTemplates = () => {

  const [step, setStep] = useState('type');

  const [typeForm] = useForm();
  const [presetsForm] = useForm();

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const createManualGroup = useMutation({
    mutationFn: async () => (
      await apiV1.post<{ id: string }>('/shop/customers/groups', { name: undefined, type: 'manual' })
    ),
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['customers-groups'] });
      navigate({ to: '/customers/groups/$groupId', params: { groupId: data.id } });
    }
  });

  function onStep1Finish(values: { type: CustomersGroupType }) {
    if (values.type === 'manual') {
      createManualGroup.mutate();
    } else {
      setStep('preset');
    }
  }

  const createAutomaticGroup = useMutation({
    mutationFn: async (values: { preset: string }) => {
      const presetData = presets.find((item) => item.value === values.preset);
      if (presetData) {
        return await apiV1.post<{ id: string }>('/shop/customers/groups', { ...presetData, type: 'automatic' });
      } else {
        throw new Error();
      }
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['customers-groups'] });
      navigate({ to: '/customers/groups/$groupId', params: { groupId: data.id } });
    }
  });

  return (
    <div>
      <h2 className={'text-xl font-medium my-4'}>Crea un nuovo gruppo</h2>
      {step === 'type' ?
        <Form key={'type'} onFinish={onStep1Finish}
              initialValues={{ type: 'automatic' }} form={typeForm} layout={'vertical'}>
          <Form.Item label={''} name={'type'}>
            <RadioCards
              options={[
                {
                  value: 'automatic',
                  label: 'Automatico',
                  description: 'I gruppi automatici aggiungono gli utenti in modo dinamico, seguendo regole configurabili. La composizione del gruppo si aggiorna costantemente in base alle regole impostate.',
                  icon: <HugeiconsIcon icon={AiBrain01Icon} />
                },
                {
                  value: 'manual',
                  label: 'Manuale',
                  description: 'In un gruppo manuale puoi selezionare direttamente i clienti che ne fanno parte, decidendo uno a uno chi includere.',
                  icon: <HugeiconsIcon icon={Hold01Icon} />
                }]} />
          </Form.Item>
          <div className={'flex justify-end'}>
            <Button loading={createManualGroup.isPending} htmlType={'submit'} type={'primary'}
                    size={'large'}>Continua <HugeiconsIcon size={16}
                                                           icon={ArrowRight01FreeIcons} /></Button>
          </div>
        </Form> :
        <Form layout={'vertical'} key={'presets'} onFinish={createAutomaticGroup.mutate} form={presetsForm}
              initialValues={{ preset: 'new_customers' }}>
          <Form.Item label={''} name={'preset'}>
            <RadioCards
              options={presets} />
          </Form.Item>
          <div className={'flex justify-end gap-2'}>
            <Button onClick={() => setStep('type')}
                    size={'large'}><HugeiconsIcon size={16}
                                                  icon={ArrowLeft01FreeIcons} /> Indietro</Button>
            <Button loading={createManualGroup.isPending} htmlType={'submit'} type={'primary'}
                    size={'large'}>Crea Gruppo <HugeiconsIcon size={16}
                                                              icon={ArrowRight01FreeIcons} /></Button>
          </div>
        </Form>
      }
    </div>

  );
};
export default CustomersGroupSelectTemplates;
